.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  align-items: center;
  padding: var(--tuna-spacing-4);
}

.scoreLine {
  font-size: var(--tuna-typography-h3-fontSize);
  margin: 0;
}

.breakdown {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  width: 100%;
  max-width: 320px;
  margin: 0;
}

.pairRow {
  display: flex;
  justify-content: space-between;
  font-variant-numeric: tabular-nums;
  color: var(--tuna-content-secondary);
}

.pairRow dt,
.pairRow dd {
  margin: 0;
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-3);
}
